"use strict";
/**
 * Structural-sharing primitives and shared sub-routines for the Settings
 * reducer. Kept separate so the per-domain reducers can stay focused on
 * action-handling.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildInitialState = exports.applyMappingAction = exports.withWorkflowReplaced = exports.withFieldReplaced = exports.withSystemReplaced = exports.removeAt = exports.replaceAt = void 0;
var ai_hub_settings_client_ids_1 = require("./ai-hub-settings-client-ids");
var ai_hub_settings_utils_1 = require("./ai-hub-settings-utils");
var ai_hub_settings_utils_2 = require("./ai-hub-settings-utils");
/* ------------------------------------------------------------------ */
/*  Array helpers — return the same reference when the index is OOB    */
/*  so React skips re-renders triggered by no-op updates.              */
/* ------------------------------------------------------------------ */
exports.replaceAt = function (items, index, next) {
    if (index < 0 || index >= items.length) {
        return items;
    }
    var result = items.slice();
    result[index] = next;
    return result;
};
exports.removeAt = function (items, index) {
    if (index < 0 || index >= items.length) {
        return items;
    }
    var result = items.slice();
    result.splice(index, 1);
    return result;
};
/* ------------------------------------------------------------------ */
/*  Section-level draft replacements                                   */
/* ------------------------------------------------------------------ */
exports.withSystemReplaced = function (draft, index, nextSystem) { return (__assign(__assign({}, draft), { systems: exports.replaceAt(draft.systems, index, nextSystem) })); };
exports.withFieldReplaced = function (draft, index, nextField) { return (__assign(__assign({}, draft), { fields: exports.replaceAt(draft.fields, index, nextField) })); };
exports.withWorkflowReplaced = function (draft, index, nextWorkflow) { return (__assign(__assign({}, draft), { workflows: exports.replaceAt(draft.workflows, index, nextWorkflow) })); };
/* ------------------------------------------------------------------ */
/*  Mapping-action application                                         */
/*                                                                     */
/*  The reducer is the only place that knows how to lazily initialize  */
/*  optional sub-objects (`valueSet`, `config`, `map`). Components     */
/*  emit pure `MappingAction`s and never construct schema sub-shapes   */
/*  themselves — eliminating the previous closure-based `updater` API  */
/*  that leaked schema knowledge into UI code.                         */
/* ------------------------------------------------------------------ */
exports.applyMappingAction = function (current, action) {
    var _a;
    switch (action.kind) {
        case 'value':
            return __assign(__assign({}, current), (_a = {}, _a[action.key] = action.value, _a));
        case 'valueSetAppend': {
            var valueSet = current.valueSet || { append: false, format: '' };
            return __assign(__assign({}, current), { valueSet: __assign(__assign({}, valueSet), { append: action.value }) });
        }
        case 'valueSetFormat': {
            var valueSet = current.valueSet || { append: false, format: '' };
            return __assign(__assign({}, current), { valueSet: __assign(__assign({}, valueSet), { format: action.value }) });
        }
        case 'config': {
            var config = current.config
                ? __assign({}, current.config) : { userNameSubField: '', emailAddressSubField: '' };
            config[action.key] = action.value;
            return __assign(__assign({}, current), { config: config });
        }
        case 'appendMapEntry':
            return __assign(__assign({}, current), { map: ai_hub_settings_utils_1.appendRecordEntry(current.map, action.defaultKeyPrefix) });
        case 'updateMapEntry':
            return __assign(__assign({}, current), { map: ai_hub_settings_utils_1.updateRecordEntry(current.map, action.entryIndex, action.key, action.value) });
        case 'removeMapEntry':
            return __assign(__assign({}, current), { map: ai_hub_settings_utils_1.removeRecordEntry(current.map, action.entryIndex) });
        default:
            return current;
    }
};
/* ------------------------------------------------------------------ */
/*  Initial-state construction                                         */
/* ------------------------------------------------------------------ */
exports.buildInitialState = function (saved) {
    var savedWithIds = ai_hub_settings_client_ids_1.assignClientIdsToSchema(ai_hub_settings_utils_2.cloneAiHubSettingsSchema(saved));
    return {
        saved: savedWithIds,
        draft: ai_hub_settings_utils_2.cloneAiHubSettingsSchema(savedWithIds),
        newSystemIds: [],
        newWorkflowIds: [],
        newFieldIds: [],
        selectedSystemId: null,
        selectedWorkflowId: null,
        selectedFieldId: null,
    };
};
